import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import routesData from "./../../../assets/apiRoutes.json";
import axios from "axios";
import notify from 'devextreme/ui/notify';
import { validate as uuidValidate } from 'uuid';
import { useParams } from 'react-router-dom';
import { LoadPanel } from 'devextreme-react/load-panel';
const position = { of: '#divContent' };

const PrintInvoice = (props) => {
    let accessToken = props.oidc.user.access_token;
    const { rowid, companyid, format } = useParams();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        try {
            if (!companyid) {
                setLoading(false);
                notify({
                    message: "Parameter 'companyid' is not valid !",
                    width: 450,
                }, 'error', 2000);
                setLoading(false);
                return;
            }
            else if (!uuidValidate(rowid)) {
                setLoading(false);
                notify({
                    message: "Parameter 'Rowid' is not valid !",
                    width: 450,
                }, 'error', 2000);
                return;
            }
            if (uuidValidate(rowid) && companyid) {
                let url = `${window._env_.REACT_APP_APIS}/${routesData.PrintInvoice.GetInvoiceReport}?rowid=${rowid}&companyid=${companyid}&format=${format}`;
                axios.get(url,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                ).then((res) => {
                    setLoading(false);
                    if (
                        res.hasOwnProperty("data") &&
                        res.data != null &&
                        res.data != undefined
                    ) {
                        if (res.data.isSuccess) {
                            window.open(
                                `${window._env_.REACT_APP_APIS}/${routesData.reports.GetReportFile}?fileName=${res.data.fileName}`,
                                "_blank"
                            );
                            notify({
                                message: 'Report Downloded!',
                                width: 100,
                            }, 'success', 2000);
                        } else {
                            notify({
                                message: "Cannot generate report. Error:  " + res.data.errorMessage,
                                width: 450,
                            }, 'error', 2000);
                        }
                    } else {
                        notify({
                            message: "Cannot generate report.",
                            width: 450,
                        }, 'error', 2000);
                    }
                });
            }
            else {
                setLoading(false);
                notify({
                    message: "Parameters are not valid!",
                    width: 450,
                }, 'error', 2000);
            }
        } catch (error) {
            setLoading(false);
            notify({
                message: "Some error occured while generating report!",
                width: 450,
            }, 'error', 2000);
        }

    }, [rowid, companyid]);
    
    return (
        <div>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                visible={loading}
                showIndicator={true}
                shading={false}
                showPane={true}
                hideOnOutsideClick={false}
                position={position}
                />
        {loading ? (
          <div style={{ textAlign: "center", fontSize: "x-large"}}>Generating Report ...</div>)
          : ("")}
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PrintInvoice);